import * as actionTypes from '../actions';
import { addItemInListOfItems, deleteItemByIdInListOfItems, updateItemInListOfItems, updateItemsInListOfItems} from "@/helpers";


const initialState = {

    questions: [],
    getQuestionsLoading: false,
    getQuestionsError: null,
    addQuestionLoading: false,
    addQuestionError: null,
    updateQuestionLoading: false,
    updateQuestionError: null,
    deleteQuestionLoading: false,
    deleteQuestionError: null,

    surveys: [],
    getSurveysLoading: false,
    getSurveysError: null,

    questionTypes: [],
    getQuestionTypesLoading: false,
    getQuestionTypesError: null,

    feedbacks: [],
    getFeedbacksLoading: false,
    getFeedbacksError: null,

    baresthoFeedbacks: [],
    getBaresthoFeedbacksLoading: false,
    getBaresthoFeedbacksError: null,

    bulkBaresthoFeedbacksLoading: false,
    bulkBaresthoFeedbacksError: null,

    baresthoFeedbacksStats: null,
    getBaresthoFeedbacksStatsLoading: false,
    getBaresthoFeedbacksStatsError: null,

    newFeedbacks: {},
    getNewFeedbacksLoading: false,
    getNewFeedbacksError: null,
};

const feedbacksReducer = (state=initialState, action) => {
    switch (action.type) {

        // GET QUESTIONS
        case actionTypes.GET_QUESTIONS_REQUEST:
            return {
                ...state,
                getQuestionsLoading: true,
            };
        case actionTypes.GET_QUESTIONS_SUCCESS:
            return {
                ...state,
                getQuestionsLoading: false,
                getQuestionsError: null,
                questions: action.data,
            };
        case actionTypes.GET_QUESTIONS_ERROR:
            return {
                ...state,
                getQuestionsLoading: false,
                getQuestionsError: action.error,
            };

        // ADD QUESTION
        case actionTypes.ADD_QUESTION_REQUEST:
            return {
                ...state,
                addQuestionLoading: true,
            };
        case actionTypes.ADD_QUESTION_SUCCESS:
            return {
                ...state,
                addQuestionLoading: false,
                addQuestionError: null,
                questions: addItemInListOfItems(state.questions, action.data),
            };
        case actionTypes.ADD_QUESTION_ERROR:
            return {
                ...state,
                addQuestionLoading: false,
                addQuestionError: action.error,
            };
        
        // UPDATE QUESTION
        case actionTypes.UPDATE_QUESTION_REQUEST:
            return {
                ...state,
                updateQuestionLoading: true,
            };
        case actionTypes.UPDATE_QUESTION_SUCCESS:
            return {
                ...state,
                updateQuestionLoading: false,
                updateQuestionError: null,
                questions: updateItemInListOfItems(state.questions, action.data),
            };
        case actionTypes.UPDATE_QUESTION_ERROR:
            return {
                ...state,
                updateQuestionLoading: false,
                updateQuestionError: action.error,
            };

        case actionTypes.SET_QUESTIONS:
            return {
                ...state,
                questions: updateItemsInListOfItems(state.questions, action.data),
            }

        // DELETE QUESTION
        case actionTypes.DELETE_QUESTION_REQUEST:
            return {
                ...state,
                deleteQuestionLoading: true,
            };
        case actionTypes.DELETE_QUESTION_SUCCESS:
            return {
                ...state,
                deleteQuestionLoading: false,
                deleteQuestionError: null,
                questions: deleteItemByIdInListOfItems(state.questions, action.data),
            };
        case actionTypes.DELETE_QUESTION_ERROR:
            return {
                ...state,
                deleteQuestionLoading: false,
                deleteQuestionError: action.error,
            };

        // GET QUESTION TYPES
        case actionTypes.GET_QUESTION_TYPES_REQUEST:
            return {
                ...state,
                getQuestionTypesLoading: true,
            };
        case actionTypes.GET_QUESTION_TYPES_SUCCESS:
            return {
                ...state,
                getQuestionTypesLoading: false,
                getQuestionTypesError: null,
                questionTypes: action.data,
            };
        case actionTypes.GET_QUESTION_TYPES_ERROR:
            return {
                ...state,
                getQuestionTypesLoading: false,
                getQuestionTypesError: action.error,
            };

        // GET FEEDBACKS
        case actionTypes.GET_FEEDBACKS_REQUEST:
            return {
                ...state,
                getFeedbacksLoading: true,
            };
        case actionTypes.GET_FEEDBACKS_SUCCESS:
            return {
                ...state,
                getFeedbacksLoading: false,
                getFeedbacksError: null,
                feedbacks: action.data,
            };
        case actionTypes.GET_FEEDBACKS_ERROR:
            return {
                ...state,
                getFeedbacksLoading: false,
                getFeedbacksError: action.error,
            };

        // BULK UPDATE FEEDBACKS
        case actionTypes.BULK_UPDATE_BARESTHO_FEEDBACKS_REQUEST:
            return {
                ...state,
                bulkBaresthoFeedbacksLoading: true,
            };
        case actionTypes.BULK_UPDATE_BARESTHO_FEEDBACKS_SUCCESS:
            return {
                ...state,
                bulkBaresthoFeedbacksLoading: false,
                bulkBaresthoFeedbacksError: null,
                baresthoFeedbacks: {
                    ...state.baresthoFeedbacks,
                    results: state.baresthoFeedbacks?.results.map(el => {
                        const part = action.data.find(data => data.id === el.id) ?? {};
                        return {...el, ...part};
                    }),
                },
            };
        case actionTypes.BULK_UPDATE_BARESTHO_FEEDBACKS_ERROR:
            return {
                ...state,
                bulkBaresthoFeedbacksLoading: false,
                bulkBaresthoFeedbacksError: action.error,
            };

        // GET FEEDBACKS
        case actionTypes.GET_FEEDBACKS_REQUEST:
            return {
                ...state,
                getFeedbacksLoading: true,
            };
        case actionTypes.GET_FEEDBACKS_SUCCESS:
            return {
                ...state,
                getFeedbacksLoading: false,
                getFeedbacksError: null,
                feedbacks: action.data,
            };
        case actionTypes.GET_FEEDBACKS_ERROR:
            return {
                ...state,
                getFeedbacksLoading: false,
                getFeedbacksError: action.error,
            };
        
        // GET BARESTHO FEEDBACKS
        case actionTypes.GET_BARESTHO_FEEDBACKS_REQUEST:
            return {
                ...state,
                getBaresthoFeedbacksLoading: true,
            };
        case actionTypes.GET_BARESTHO_FEEDBACKS_SUCCESS:
            return {
                ...state,
                getBaresthoFeedbacksLoading: false,
                getBaresthoFeedbacksError: null,
                baresthoFeedbacks: action.data,
            };
        case actionTypes.GET_BARESTHO_FEEDBACKS_ERROR:
            return {
                ...state,
                getBaresthoFeedbacksLoading: false,
                getBaresthoFeedbacksError: action.error,
            };
        
        // GET BARESTHO FEEDBACKS STATS
        case actionTypes.GET_BARESTHO_FEEDBACKS_STATS_REQUEST:
            return {
                ...state,
                getBaresthoFeedbacksStatsLoading: true,
            };
        case actionTypes.GET_BARESTHO_FEEDBACKS_STATS_SUCCESS:
            return {
                ...state,
                getBaresthoFeedbacksStatsLoading: false,
                getBaresthoFeedbacksStatsError: null,
                baresthoFeedbacksStats: action.data !== ''? action.data: null,
            };
        case actionTypes.GET_BARESTHO_FEEDBACKS_STATS_ERROR:
            return {
                ...state,
                getBaresthoFeedbacksStatsLoading: false,
                getBaresthoFeedbacksStatsError: action.error,
            };
        // GET SURVEYS
        case actionTypes.GET_SURVEYS_REQUEST:
            return {
                ...state,
                getSurveysLoading: true,
            };
        case actionTypes.GET_SURVEYS_SUCCESS:
            return {
                ...state,
                getSurveysLoading: false,
                getSurveysError: null,
                surveys: action.data,
            };
        case actionTypes.GET_SURVEYS_ERROR:
            return {
                ...state,
                getSurveysLoading: false,
                getSurveysError: action.error,
            };

        // GET SURVEYS
        case actionTypes.GET_NEW_FEEDBACKS_REQUEST:
            return {
                ...state,
                getNewFeedbacksLoading: true,
            };
        case actionTypes.GET_NEW_FEEDBACKS_SUCCESS:
            return {
                ...state,
                getNewFeedbacksLoading: false,
                getNewFeedbacksError: null,
                newFeedbacks: action.data,
            };
        case actionTypes.GET_NEW_FEEDBACKS_ERROR:
            return {
                ...state,
                getNewFeedbacksLoading: false,
                getNewFeedbacksError: action.error,
            };

        default:
            return state;
    }
};

export default feedbacksReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/feedbacks.js